import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";
import { resultOf } from "../../common/utilities";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

function TableHeaderCell(props) {
  const {
    columnKey,
    label,
    align,
    // eslint-disable-line no-unused-vars
    className,
    noWrap,
    // eslint-disable-line no-unused-vars
    header,
    style,
    headerCellComponent: TH,
    headerCellComponentProps
  } = _objectSpread({}, props);

  let headerContent;

  if (header !== null) {
    headerContent = resultOf(header, _objectSpread({
      key: columnKey
    }, props));
  } else if (label !== null) {
    headerContent = label;
  } else {
    headerContent = columnKey;
  }

  const thProps = _objectSpread({}, headerCellComponentProps);

  if (typeof TH === "function") {
    thProps.column = props;
  }

  const HEAD = headerContent === "" ? "td" : TH;
  const tableHeaderCellClassName = clsx("pnr-table__header", className);
  return _jsx(HEAD, _objectSpread(_objectSpread({
    scope: HEAD === "td" ? null : "col",
    className: tableHeaderCellClassName,
    style: style
  }, thProps), {}, {
    children: headerContent
  }));
}

TableHeaderCell.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The key to locate the record */
  columnKey: PropTypes.string.isRequired,

  /** The alignment of cells, can be `left`, `center` or `right` */
  align: PropTypes.oneOf(["left", "center", "right"]),

  /** Additional class names separated by a space to add to the `<TH>` */
  className: PropTypes.string,

  /**
   * The header content for the column.
   * Overrides `columns.label` prop.
   * One of type: `string`, `func`.
   */
  header: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

  /** The Component that renders the header cell */
  headerCellComponent: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

  /** The extra props passed to the headerCellComponent */
  headerCellComponentProps: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types

  /**
   * The display label for the header or column information.
   * Overridden by `columns.header` prop.
   */
  label: PropTypes.string,

  /** Describes if the text content should be wrapped` */
  noWrap: PropTypes.bool,

  /** Additional styles for `<TH>` */
  style: PropTypes.object // eslint-disable-line react/forbid-prop-types

} : {};
TableHeaderCell.defaultProps = {
  label: null,
  header: null,
  align: null,
  className: "",
  noWrap: false,
  style: null,
  headerCellComponent: "th",
  headerCellComponentProps: null
};
export default TableHeaderCell;